import { useCallback } from "react"

export type ILocal = "en" | "en-US" | "en-us" | "en-GB" | "de" | "de-DE" | "ca" | "en-CA" | "de-EU" | "nl-NL" | "eu-EU"
export type ICurrency = "USD" | "GBP" | "EUR" | "CAD"

export const localCurrencyMap: Record<ILocal, ICurrency> = {
  "en": "USD",
  "en-US": "USD",
  "en-us": "USD",
  "en-GB": "GBP",
  'de-DE': "EUR",
  'de': "EUR",
  "de-EU": "EUR",
  'en-CA': "CAD",
  'ca': "CAD",
  "nl-NL": "EUR",
  "eu-EU": "EUR"
}

const LocalesMap: Record<string, string> = {
  "en": "en-US",
  "en-US": "en-US",
  "en-us": "en-US",
  "en-GB": "de",
  'de-DE': "de",
  'de': "de",
  'en-CA': "en-US",
  'ca': "en-US", // ca 要用 en-US 才能显示正确的 CA$
  "de-EU": "de-EU",
  "nl-NL": "nl-NL",
  "eu-EU": "de-EU"
}

const useFormatPrice = (locale: string = "en-US") => {
  // const { locale = "en-US" } = useParams<{ locale: string }>()
  const formatPrice = useCallback(
    (price: number = 0) => {
      price = isNaN(price) ? 0 : price
      return new Intl.NumberFormat(LocalesMap[locale!] || 'en-US', {
        style: "currency",
        currency: localCurrencyMap[locale! as ILocal] || "USD",
        minimumFractionDigits: 0,
        // 移动端浏览器版本较低, 不支持 narrowSymbol
        currencyDisplay: "symbol",
      }).format(price)
    },
    [locale]
  )
  return formatPrice
}
export default useFormatPrice
